import axios from 'axios';
import { API_BASE_URL, config } from '../constants/api';

export const fetchAdminList = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-admins`,config);
  return res.data;
};

export const addUser = async (user) => {
  const res = await axios.post(`${API_BASE_URL}/users`, user);
  return res.data;
};
export const signInAdmin = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/login-admin`,data);
  return res.data;
};
export const addAppAdminOrAgent = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/add-admin`,data,config);
  return res.data;
};
export const deleteSubAdmin = async (id) => {
  const res = await axios.post(`${API_BASE_URL}/admin/delete-admin/${id}`,{},config);
  return res.data;
};
export const updateAppAdminOrAgent = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/update-admin/${data?.id}`,data,config);
  return res.data;
};

export const fetchUserList = async (appID) => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-user-list-by-role?appID=${appID ? appID : ""}`,config);
  return res.data;
};
export const fetchAppList = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-app-list`,config);
  return res.data;
};
export const fetchUnassignedAppList = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-unassigned-app-list`,config);
  return res.data;
};
export const addAppRegister = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/register-app`,data,config);
  return res.data;
};
export const updateApp = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/update-app-by-admin/${data?.id}`,data,config);
  return res.data;
};
export const deleteApp = async (id) => {
  const res = await axios.post(`${API_BASE_URL}/admin/delete-app/${id}`,{},config);
  return res.data;
};
export const addPaymentGatewayRegister = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/add-payment-gatway`,data,config);
  return res.data;
};
export const fetchGateWayList = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-payment-gateway-list`,config);
  return res.data;
};
export const updateGateway = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/update-payment-gateway/${data?.id}`,data,config);
  return res.data;
};
export const deleteGateWay = async (id) => {
  const res = await axios.post(`${API_BASE_URL}/admin/delete-gateway-data/${id}`,{},config);
  return res.data;
};
export const fetchActiveGateWayList = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-active-payment-gateway-list`,config);
  return res.data;
};
export const fetchAdminDetails = async () => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-admin-details`,config);
  return res.data;
};
export const fetchAdminDetailsById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/admin/get-admin-details-by-id/${id}`,config);
  return res.data;
};
export const addUserHost = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/admin/register-user-host-by-agent`,data,config);
  return res.data;
};
export const updateUserHost = async (data,id) => {
  const res = await axios.post(`${API_BASE_URL}/admin/update-user/${id}`,data,config);
  return res.data;
};
export const deleteUserHost = async (id) => {
  const res = await axios.post(`${API_BASE_URL}/admin/delete-user-by-admin/${id}`,{},config);
  return res.data;
};
